import {
  DAILY_OCCUPANCY_REQUEST,
  GET_MPI_ELEMENT_REQUEST,
  GET_PERFORMANCE_SUMMARY_REQUEST,
  GET_RESERVATIONS_DISTRIBUTION_BY_CHANNEL_REQUEST,
  GET_REVENUE_BY_YEAR_REQUEST,
  GET_RATING_REVIEWS_REQUEST,
  GET_RESERVATIONS_SUMMARY_REQUEST,
  GET_LISTINGS_DATA_REQUEST,
  GET_REVENUE_PER_AVAILABLE_NIGHT_REQUEST,
  GET_YEARLY_REVENUE_BY_MONTH_REQUEST,
} from "@/redux/actions";

export const PERFORMANCE_PAGE_ACTIONS_TO_DISPATCH = [
  GET_PERFORMANCE_SUMMARY_REQUEST,
  DAILY_OCCUPANCY_REQUEST,
  GET_MPI_ELEMENT_REQUEST,
  GET_REVENUE_BY_YEAR_REQUEST,
  GET_RATING_REVIEWS_REQUEST,
  GET_RESERVATIONS_SUMMARY_REQUEST,
  GET_LISTINGS_DATA_REQUEST,
  GET_REVENUE_PER_AVAILABLE_NIGHT_REQUEST,
  GET_YEARLY_REVENUE_BY_MONTH_REQUEST,
  GET_RESERVATIONS_DISTRIBUTION_BY_CHANNEL_REQUEST,
];
